import { BrowserStorage } from './base-storage';

export const browserLocalStorage = new BrowserStorage('localStorage');
